/* eslint-disable max-classes-per-file */
// tslint:disable-next-line:max-classes-per-file
import { Delivery } from 'src/app/models/delivery.model';
import { Action } from '@ngrx/store';
import { UserCredentials } from 'src/app/models/userCredential.model';
import { Position } from 'src/app/models/position.model';
import { SetTransactionName, ChangeOrder, SetForwardToChange, ResetPositionToOriginal, SetReturnReasonCode, SetUserCredentials, UpdateSelectedPosition, SetRefreshUserData, SetUserAddress,
     RemoveForwardToAgent, SetCID, SetCameFromOverview, SetPostalShoppingScenario, SetPostalShoppingCustomPositions } from './order-details-extend.actions';
/** OrderDetailsActionTypes */
export enum OrderDetailsActionTypes {
    LOAD_ORDER_DETAILS_REQUEST = 'LOAD_ORDER_DETAILS_REQUEST',
    LOAD_ORDER_DETAILS_SUCCESS = 'LOAD_ORDER_DETAILS_SUCCESS',
    LOAD_ORDER_DETAILS_FAILURE = 'LOAD_ORDER_DETAILS_FAILURE',
    LOAD_ORDER_DETAILS_More_Info = 'LOAD_ORDER_DETAILS_More_Info',
    SELECT_POSITION = 'SELECT_POSITION',
    RESET_ORDER = 'RESET_ORDER',
    SET_TRANSACTION_NAME = 'SET_TRANSACTION_NAME',
    SET_FORWARD_TO_AGENT = 'SET_FORWARD_TO_AGENT',
    SET_RETURN_REASON_CODE = 'SET_RETURN_REASON_CODE',
    CHANGE_ORDER = 'CHANGE_ORDER',
    RESET_POSITION = 'RESET_POSITION_To_Original',
    SET_USER_CREDENTIALS = 'SET_USER_CREDENTIALS',
    UPDATE_SELECTED_POSITION = 'UPDATE_SELECTED_POSITION',
    REMOVE_BEFORE_UNLOAD_LISTENER = 'REMOVE_BEFORE_UNLOAD_LISTENER',
    SET_REFRESH_USER_DATA = 'SET_REFRESH_USER_DATA',
    SET_USER_ADDRESS = 'SET_USER_ADDRESS',
    REMOVE_FORWARD_TO_AGENT = 'REMOVE_FORWARD_TO_AGENT',
    NO_ACTIONS= 'NO_ACTION',
    SET_C_ID = 'SET_C_ID',
    SET_CAME_FROM_OVERVIEW = 'SET_CAME_FROM_OVERVIEW',
    SET_POSTAL_SHOPPING_SCENARIO = 'SET_POSTAL_SHOPPING_SCENARIO',
    SET_POSTAL_SHOPPING_CUSTOM_POSITIONS = 'SET_POSTAL_SHOPPING_CUSTOM_POSITIONS',

}
/** OrderDetailsRequest */
export class OrderDetailsRequest implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.LOAD_ORDER_DETAILS_REQUEST;
    /** constructor */
    public constructor (public payload: {
        /** userCredentials */
        userCredentials: UserCredentials }) { }
}
/** OrderDetailsSuccess */
export class OrderDetailsSuccess implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.LOAD_ORDER_DETAILS_SUCCESS;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** delivery */
        delivery: Delivery,
        /** moreInfo */
        moreInfo: boolean,
        /** loggedIn */
        loggedIn: boolean,
    }) { }
}
/** OrderDetailsFaliure */
export class OrderDetailsFaliure implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.LOAD_ORDER_DETAILS_FAILURE;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** errrObject */
        errrObject: any,
        /** moreInfo */
        moreInfo: boolean,
        /** loggedIn */
        loggedIn: boolean,
    }) { }

}
/** OrderDetailsMoreInfo */
export class OrderDetailsMoreInfo implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.LOAD_ORDER_DETAILS_More_Info;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** moreinfo */
        moreInfo: boolean,
        /** loggedIn */
        loggedIn: boolean,
    }) { }

}
/** UpdatePosition */
export class UpdatePosition implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.SELECT_POSITION;
    /**
     *
     * @param payload
     */
    public constructor (public payload: {
        /** changedPosition */
        changedPosition: { [key: number]: Position[]; },
    }) { }

}
/** ResetOrder */
export class ResetOrder implements Action {
    /** type */
    public readonly type = OrderDetailsActionTypes.RESET_ORDER;
}
/** OrderDetailsActions */
export type OrderDetailsActions = OrderDetailsRequest | OrderDetailsSuccess | OrderDetailsFaliure
    | OrderDetailsMoreInfo | UpdatePosition | ResetOrder | SetTransactionName | ChangeOrder | SetForwardToChange | RemoveForwardToAgent |
    ResetPositionToOriginal | SetReturnReasonCode | SetUserCredentials | UpdateSelectedPosition |
    SetRefreshUserData | SetUserAddress | SetCID | SetCameFromOverview | SetPostalShoppingScenario | SetPostalShoppingCustomPositions;
